import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './AuthContext.jsx';
import AppWrapper from './AppWrapper';
import AnalyticsTracker from "./components/AnalyticsTracker";
import ScrollToTop from './components/ScrollToTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>

        <AnalyticsTracker />
        <ScrollToTop />

        <AppWrapper />
        <ToastContainer position="top-center" />

      </BrowserRouter>
    </AuthProvider>
  );
}